import qs from "qs";

export class Sap {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/sap`;
  }

  async codeList() {
    const url = `${this.baseURL}/material/code`;

    const response = await this.httpClient.request("get", url);

    return response
  }

  async groupList() {
    const url = `${this.baseURL}/material/group`;

    const response = await this.httpClient.request("get", url);

    return response
  }

  async unitList() {
    const url = `${this.baseURL}/material/unit`;

    const response = await this.httpClient.request("get", url);

    return response
  }

  async postMaterialCode(params) {
    const url = `${this.baseURL}/material/code`;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async getSapFiReportList(params) {
    const queryString = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/fi/report${queryString}`;

    const config = params && params.format === "xlsx"
      ? { responseType: "blob" }
      : undefined;

    const response = await this.httpClient.request("get", url, config);

    return response;
  }

  async getSapMmReportList(params) {
    const queryString = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/mm/report${queryString}`;

    const config = params && params.format === "xlsx"
      ? { responseType: "blob" }
      : undefined;

    const response = await this.httpClient.request("get", url, config);

    return response;
  }

  async getSapFiErrorReportList(params) {
    const queryString = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/fi/error/report${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getSapMmErrorReportList(params) {
    const queryString = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/mm/error/report${queryString}`;

    const config = params && params.format === "xlsx"
      ? { responseType: "blob" }
      : undefined;

    const response = await this.httpClient.request("get", url, config);

    return response;
  }

  async getSapVenderReportList(params) {
    const queryString = qs.stringify(params, { addQueryPrefix: true });
    const url = `${this.baseURL}/mm/vender/report${queryString}`;

    const config = params && params.format === "xlsx"
      ? { responseType: "blob" }
      : undefined;

    const response = await this.httpClient.request("get", url, config);

    return response
  }

  async putNotSendSapFiByDocumentNumbers(params) {
    const url = `${this.baseURL}/not/send/fi/receipt`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/sap.js